import React from "react";
import Loader from "../../../components/ui/Loader/Loader";
import DateService from "../../../services/DateService";
import Status from "../../../components/ui/Status";

const PassCodeDetail = ({ data, loading }) => {

    if (loading) {
        return (
            <div className="text-center">
                <Loader />
            </div>
        );
    }

    if (!data) {
        return (
            <div className="text-center">
                No Data Available
            </div>
        );
    }

    const getSitesDisplay = (siteData) => {
        if (!siteData || siteData.length === 0) return "-";

        const siteNames = siteData.map(site => site.name);
        if (siteNames.length <= 2) {
            return siteNames.join(", ");
        }
        return `${siteNames.slice(0, 2).join(", ")} +${siteNames.length - 2} more`;
    }

    const getVisibilityDisplay = (visibility) => {
        if (!visibility || visibility.length === 0) return "-";

        return visibility
            .map(item =>
                item
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, char => char.toUpperCase())
            )
            .join(", ");
    };

    return (
        <section className="bg-white">
            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <button className="nav-link active">
                        Details
                    </button>
                </li>
            </ul>

            <div className="tab_content_header">
                <div className="tab_content_wrapper mt-2">
                    <span className="content_heading">Passcode Details</span>
                </div>

                <table className="table table-hover table-borderless mt-2">
                    <tbody>
                        <tr>
                            <td className="details-label" width="35%">
                                Passcode
                            </td>
                            <td className="details-name">
                                {data.passcode || '-'}
                            </td>
                        </tr>

                        <tr>
                            <td className="details-label">
                                Status
                            </td>
                            <td className="details-name">
                                <Status color={data.status?.status_color_code}>
                                    {data.status?.status_text}
                                </Status>
                            </td>
                        </tr>

                        <tr>
                            <td className="details-label">
                                Expiry Date
                            </td>
                            <td className="details-name">
                                {DateService.dateFormat(data.expiry_date)}
                            </td>
                        </tr>

                        <tr>
                            <td className="details-label">
                                Visibility
                            </td>
                            <td className="details-name">
                                {getVisibilityDisplay(data.visibility)}
                            </td>
                        </tr>

                        <tr>
                            <td className="details-label">
                                Sites
                            </td>
                            <td className="details-name">
                                {getSitesDisplay(data.site_data)}
                            </td>
                        </tr>

                        <tr>
                            <td className="details-label">
                                Created By
                            </td>
                            <td className="details-name">
                                {data.created_by || "-"}
                            </td>
                        </tr>

                        <tr>
                            <td className="details-label">
                                Created At
                            </td>
                            <td className="details-name">
                                {DateService.dateTimeFormat
                                    ? DateService.dateTimeFormat(data.created_at)
                                    : data.created_at || '-'}
                            </td>
                        </tr>

                        <tr>
                            <td className="details-label">
                                Updated By
                            </td>
                            <td className="details-name">
                                {data.updated_by || "-"}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    );
};

export default PassCodeDetail;